import * as React from 'react';
import styles from './FastGoldLink.scss';
import { interpolate, t } from '~/utils/localization';
import classNames from 'classnames';
import { playButtonGoldClickSound } from '~/api/WoWsClient';

interface IFastGoldLink {
    withIcon?: boolean;
    className?: string;
    showCouponTip?: boolean;
    onClick: (event?: React.MouseEvent) => void;
}

const FastGoldLink = ({ withIcon, onClick, className, showCouponTip }: IFastGoldLink) => {
    const onClickHandler = (event: React.MouseEvent) => {
        const target = event.target as HTMLElement;
        if (target.dataset.type === 'fast-link') {
            playButtonGoldClickSound();
            onClick(event);
        }
    };

    return (
        <div className={classNames(styles.wrapper, className)} onClick={onClickHandler}>
            {showCouponTip ? (
                <div
                    className={styles.linkWrapper}
                    dangerouslySetInnerHTML={{
                        __html: interpolate(t('Вы можете {open}Купить дублоны{close} либо выбрать купон'), {
                            open: `<span class="${classNames(styles.link, styles.withIcon, styles.inlineLink)}"><span data-type="fast-link">`,
                            close: `</span></span>`,
                        }),
                    }}
                />
            ) : (
                <span
                    className={classNames(styles.link, {
                        [styles.withIcon]: withIcon,
                    })}
                    onClick={(event) => {
                        playButtonGoldClickSound();
                        onClick(event);
                    }}
                >
                    <span>{t('Купить дублоны')}</span>
                </span>
            )}
        </div>
    );
};

export default FastGoldLink;
